export default {"src":"/_next/static/media/person.242154e6.svg","height":24,"width":24};